export default __webpack_public_path__ + "static/Hero-mobile-3e72049ba764d851a761ceb0fcc575ff.png";